import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCarrierOfferHistory extends Layout {
    sourceCarrierOfferHistory: DataSource;
    tableOfferHistory: Table;
}
